import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  mediaFadeRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'
import { SplitTextEngine } from '@/utils/split-text'

import { Animation } from '@/types'

export const imageFullMediaRevealAnimation = ({
  node,
  reverse,
  delay = 0
}: Animation) => {
  const timeline = gsap
    .timeline({
      ...getScrollTriggerOptions(node, reverse),
      delay
    })
    .add(mediaFadeRevealAnimation(node).timeline, 0)

  return () => {
    timeline.kill()
  }
}

export const imageFullRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const pretitle = selector('[data-motion-pretitle]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]
  const cta = selector('[data-motion-cta]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let pretitleAnimation: SharedAnimation
  if (pretitle) {
    pretitleAnimation = linesRevealAnimation(pretitle, reverse)
    timeline.add(pretitleAnimation.timeline, 0)
  }

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse, SplitTextEngine.AT)
    timeline.add(titleAnimation.timeline, 0)
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = fadeRevealAnimation(paragraph)
    timeline.add(paragraphAnimation.timeline, 0.2)
  }

  let ctaAnimation: SharedAnimation
  if (cta) {
    ctaAnimation = fadeRevealAnimation(cta)
    timeline.add(ctaAnimation.timeline, 0.3)
  }

  return () => {
    timeline.kill()

    pretitleAnimation?.revert()
    titleAnimation?.revert()
    paragraphAnimation?.revert()
    ctaAnimation?.revert()
  }
}
